/**
 * Base class for creating specific constant reference wrappers
 */
class AbstractConstantReference {
    constructor(_target, _key) {
        this._target = _target;
        this._key = _key;
    }
    get_property(property_name) {
        return this._target[this._key][property_name];
    }
    set_property(property_name, value) {
        this._target[this._key][property_name] = value;
    }
    get_value() {
        return this._target[this._key];
    }
    set_value(value) {
        this._target[this._key] = value;
    }
}
/**
 * A constant reference is an object wrapping a property on another object,
 * letting the user interact with it as if it was a constant object (never assigned to a new object)
 * Even if the underlying implementation gives no such guarantees.
 */
export class Color3ConstantReference extends AbstractConstantReference {
    constructor(_target, _key, _mark_dirty) {
        super(_target, _key);
        this._mark_dirty = _mark_dirty;
    }
    get r() {
        return this.get_property('r');
    }
    set r(val) {
        var _a;
        if (this.get_property('r') !== val) {
            this.set_property('r', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
    get g() {
        return this.get_property('g');
    }
    set g(val) {
        var _a;
        if (this.get_property('g') !== val) {
            this.set_property('g', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
    get b() {
        return this.get_property('b');
    }
    set b(val) {
        var _a;
        if (this.get_property('b') !== val) {
            this.set_property('b', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
}
export class VectorColorConstantReference extends AbstractConstantReference {
    constructor(_target, _key, _mark_dirty) {
        super(_target, _key);
        this._mark_dirty = _mark_dirty;
    }
    get x() {
        return this.get_property('r');
    }
    set x(val) {
        var _a;
        if (this.get_property('r') !== val) {
            this.set_property('r', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
    get y() {
        return this.get_property('g');
    }
    set y(val) {
        var _a;
        if (this.get_property('g') !== val) {
            this.set_property('g', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
    get z() {
        return this.get_property('b');
    }
    set z(val) {
        var _a;
        if (this.get_property('b') !== val) {
            this.set_property('b', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
}
export class Vector3ConstantReference extends AbstractConstantReference {
    constructor(_target, _key, _mark_dirty) {
        super(_target, _key);
        this._mark_dirty = _mark_dirty;
    }
    get x() {
        return this.get_property('x');
    }
    set x(val) {
        var _a;
        if (this.get_property('x') !== val) {
            this.set_property('x', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
    get y() {
        return this.get_property('y');
    }
    set y(val) {
        var _a;
        if (this.get_property('y') !== val) {
            this.set_property('y', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
    get z() {
        return this.get_property('z');
    }
    set z(val) {
        var _a;
        if (this.get_property('z') !== val) {
            this.set_property('z', val);
            (_a = this._mark_dirty) === null || _a === void 0 ? void 0 : _a.call(this);
        }
    }
}
export class Vector3ConstantPropertyReference extends AbstractConstantReference {
    get x() {
        return this.get_property('x');
    }
    set x(val) {
        const { y, z } = this.get_value();
        this.set_value({ x: val, y: y, z: z });
    }
    get y() {
        return this.get_property('y');
    }
    set y(val) {
        const { x, z } = this.get_value();
        this.set_value({ x: x, y: val, z: z });
    }
    get z() {
        return this.get_property('z');
    }
    set z(val) {
        const { x, y } = this.get_value();
        this.set_value({ x: x, y: y, z: val });
    }
}
//# sourceMappingURL=PropertyWrappers.js.map